<ion-header translucent>
  <ion-toolbar>
    <ion-title>{{ 'Select Payment Method' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismissModal(false)">{{ 'Close' | translate }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content fullscreen>
  <ion-list>
    <ng-container *ngIf="calculationsComplete">
      <!-- Only show list after calculations -->
      <ng-container *ngFor="let item of paymentMethods">
        <ion-item lines="full" class="ion-activatable ripple-parent" (click)="onSelectPaymentGateway(item)"
          [disabled]="(item.title === 'Card Payment' && !basicInfo?.cardTermsAndConditions)">
          <ion-label>
            <h2>
              {{
              item.title === 'Cash On Delivery'
              ? ('CASH_PAYMENT' | translate)
              : item.title === 'Card Payment'
              ? ('MANUAL_CARD_ENTRY' | translate)
              : (item.title | translate)
              }}
            </h2>

            <!-- Display Tastio Fee only when calculations are complete -->
            <!-- <p *ngIf="(item.title !== 'Cash On Delivery')">
              {{ 'TAPGO_FEE' | translate }}:
              <span *ngIf="calculationsComplete">
                +{{ calculateProcessingFee(item) | currency : basicInfo?.currencyCode }}
              </span>
              <span *ngIf="!calculationsComplete">{{ 'CALCULATING' | translate }}</span>
            </p> -->
            <p>{{ 'No extra fee' |
              translate }}</p>
          </ion-label>

          <!-- Show total or "Calculating..." placeholder based on calculationsComplete -->
          <ion-note slot="end" color="primary">
            <span *ngIf="calculationsComplete">
              {{ (dataPayload.totalAmount || 0) | currency : basicInfo?.currencyCode }}
            </span>
            <span *ngIf="!calculationsComplete">{{ 'Calculating total...' | translate }}</span>
          </ion-note>

          <ion-ripple-effect></ion-ripple-effect>
        </ion-item>
      </ng-container>
    </ng-container>


    <!-- Loyalty Points Option -->
    <ion-item lines="full" class="ion-activatable ripple-parent"
      (click)="onSelectPaymentGateway({ title: 'Loyalty Points' })"
      *ngIf="dataPayload?.customer?.loyaltyPoints > 0 && isLoyaltyMgmtEnabled && calculationsComplete"
      [disabled]="notEnoughPoints || isExpired" [class.disabled]="notEnoughPoints">
      <div class="loyalty-points-lbl">
        <ion-icon class="icon" name="ribbon" color="warning"></ion-icon>
        <ion-label>
          <h2>
            {{ 'LOYALTY_POINTS_BALANCE' | translate }}
            <ion-badge *ngIf="isExpired" class="bg-medium-2 color-dark-5 badge-center">
              {{ 'EXPIRED' | translate }}
            </ion-badge>
          </h2>
          <p>
            {{"Initial" | translate}}: {{ dataPayload?.customer?.loyaltyPoints }} {{"Pts" | translate }}
          </p>
          <p *ngIf="!notEnoughPoints">
            {{"After Deduction"|translate}}: {{ dataPayload?.customer?.loyaltyPoints - spendablePoints }} {{"Pts" |
            translate }}
          </p>
          <p *ngIf="notEnoughPoints" class="error-text">
            {{ 'NOT_ENOUGH_POINTS' | translate }}
          </p>
        </ion-label>
      </div>
      <span class="loyalty-points-btn" *ngIf="!notEnoughPoints">
        <span class="points-badge">
          <ion-icon name="ribbon" color="warning"></ion-icon>
          -{{ spendablePoints }} {{'Pts' | translate}}
        </span>
        <ng-container *ngIf="calculationsComplete && remainingAmount > 0">
          <span class="ml-3">+</span>
          <span class="color-primary ml-2">{{ remainingAmount | currency : basicInfo?.currencyCode }}</span>
        </ng-container>
      </span>
      <ion-ripple-effect></ion-ripple-effect>
    </ion-item>
  </ion-list>
</ion-content>